import React ,{ useEffect, useState} from "react";
import Admin from "./Admin"
import College from "./College"
import Mentor from "./Mentor"
import Trainer from "./Trainer"
import Util from "../Service/util";
import { useNavigate } from "react-router-dom";

function Main() {

  let [ role, SetRole] = useState("student");
  const util = new Util();
  const navigate = useNavigate();

  useEffect(()=>{
    
    const user = util.getUserDetails();
    SetRole(user.role);
    if(user.role === 'student') navigate(`/profile/${user?._id}`);
    
  },[])

  const RoleBasedView = ({role}) => {
    switch(role) {
      case 'admin' : return <Admin/>
      case 'trainer' : return <Trainer/>
      case 'mentor' : return <Mentor/>
      case 'college' : return <College/>
      default : return null;
    }
  }
  return (
    <div className="">
      <div className="container-fuild d-flex justify-content-center flex-column">
        {
          <RoleBasedView role={role}/>
          }
      </div>
    </div>
  );
}

export default Main;
